//@flow

import React, { useState } from 'react';
import Slider from 'react-slick';

import api from '../../lib/api';

import { WhitePanel } from '../index';
import SkeletonCard from '../Cards/SkeletonCard';

import './cardSlider.css';

// import '../../../../../node_modules/react-rater/lib/react-rater.css';
// import '../../../../../node_modules/react-rater/lib/react-rater.css';

type GalleryArrowProps = {
  onClick: () => void,
  direction: string,
  name: string,
};

function GalleryArrow(props: GalleryArrowProps) {
  const { onClick, direction, name } = props;

  return (
    <div className={`control ${direction}`}>
      <div aria-label={name} role="button" className="action" onClick={onClick}>
        <i className={`icon icon-hg-chev-${direction}`} />
      </div>
    </div>
  );
}

const settings = toShow => ({
  infinite: false,
  slidesToShow: toShow,
  slidesToScroll: 1,
  autoplay: false,
  swipe: true,
  dots: false,
  nextArrow: <GalleryArrow direction="right" name="Right Arrow" />,
  prevArrow: <GalleryArrow direction="left" name="Left Arrow" />,
  responsive: [
    {
      breakpoint: 1200,
      settings: { infinite: false, slidesToShow: toShow, slidesToScroll: 1 },
    },
    {
      breakpoint: 1024,
      settings: { infinite: false, slidesToShow: 4, slidesToScroll: 1 },
    },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
});

type Props = {
  title: string,
  endpoint: string,
  showNoOfCards: number,
  Card: React.ReactElement,
};

const cached = new Map();

CardsSlider.defaultProps = {
  showNoOfCards: 5,
};

function CardsSlider(props: Props) {
  const { endpoint, title, Card, showNoOfCards } = props;
  const [cards, setCards] = useState(cached.get(endpoint));

  React.useEffect(() => {
    if (cards && cards.length >= 0) return;

    api.get(endpoint).then(({ data }) => {
      setCards(data);
      cached.set(endpoint, data);
    });
  }, [endpoint, cards]);

  return (
    <WhitePanel title={title}>
      <Slider {...settings(showNoOfCards)} className="featured-slider">
        {cards && cards.length > 0
          ? cards.map(cardData => (
              <div key={cardData.id} className="item">
                <Card cardData={cardData} />
              </div>
            ))
          : Array.from({ length: showNoOfCards }, id => (
              <div key={id + 1} className="item">
                <SkeletonCard />
              </div>
            ))}
      </Slider>
    </WhitePanel>
  );
}

export default CardsSlider;



// WEBPACK FOOTER //
// ./src/components/CardsSlider/CardsSlider.js